{
  "activeMiners": "Active Miners",
  "approvedRewards": "Approved Rewards",
  "assetOverview": "Account & Assets",
  "buyExalt": "Buy EXALT",
  "community": "Community",
  "dashboardSubtitle": "Professional Digital Asset Exchange",
  "dashboardTitle": "Dashboard",
  "displayCurrency": "Display currency",
  "earn": "Earn",
  "estimatedExchangeWalletValue": "Estimated Exchange Wallet Value",
  "exchangeActivity": "Exchange Activity",
  "hideBalances": "Hide balances",
  "leaderboard": "Leaderboard",
  "live": "LIVE",
  "liveMarketBoard": "● Live Market Board",
  "loading": "Loading...",
  "marketCap": "Market Cap",
  "marketStatus": "Market Status",
  "miningPool": "Mining Pool",
  "noActivityYet": "No Activity Yet",
  "notifications": "Notifications",
  "pendingRewards": "Pending Rewards",
  "portfolioValue": "Portfolio Value",
  "quickActions": "Quick Actions",
  "readyTradingWithdrawal": "Ready for Trading or Withdrawal",
  "recentActivity": "Recent Activity",
  "recentOrders": "Recent Orders",
  "refresh": "Refresh",
  "refreshDashboard": "Refresh Dashboard",
  "security": "Security & Verification",
  "showBalances": "Show balances",
  "submitListing": "Submit Listing",
  "topGainer": "Top Gainer",
  "topLoser": "Top Loser",
  "totalPortfolioValue": "Total Portfolio Value",
  "trendingCoins": "Trending Coins",
  "unavailable": "Unavailable",
  "viewMarketBoard": "View Market Board",
  "waitingAdminApproval": "Waiting for Admin Approval",
  "walletStatus": "Wallet Status"
}